export const getStoredAuthUser = () => {
    if (typeof window === 'undefined') return null;
    try {
        const raw = window.localStorage.getItem('authUser');
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

export const resolveAuthUserName = (authUser) => (
    authUser?.fullName
    || authUser?.displayName
    || authUser?.username
    || authUser?.email
    || ''
);

export const resolveLeadOwnerName = (lead, authUser) => {
    if (!lead) return 'Unassigned';
    const currentName = resolveAuthUserName(authUser);
    if (lead.assignedTo && authUser?.uid && lead.assignedTo === authUser.uid) {
        return currentName || lead.assignedToName || 'Unassigned';
    }
    return lead.assignedToName || 'Unassigned';
};
